/**
 * Canonical GHL contact deep-link. Shared by BulkOpenInGHL (bulk action bar) and
 * CardActions (per-card row). Kept in its own module so exporting it doesn't trip
 * react-refresh/only-export-components on the component files.
 *
 * Format verified against the live GHL app (S29). `/contacts/detail/{contactId}` —
 * NOT the conversation URL, which redirects to the latest convo (broken deep-link).
 */
export function buildGhlContactUrl(locationId: string, contactId: string): string {
  return `https://app.gohighlevel.com/v2/location/${locationId}/contacts/detail/${contactId}`;
}
